"use client"

import { Utensils } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UtensilsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UtensilsIcon = component(Icon)({ as: Utensils })
